export const concatField = `
{
  profileId: contactId,
  userName: contactName,
  userPhone: contactTelephone
}
`
